/** Common HTTP status codes used by the Core API client and consumers. */
export const HTTP_STATUS = {
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	CREATED: 201,
	CONFLICT: 409,
} as const;
